export const projects = [
  {
    id: 1,
    title: 'GYANSETU - Mobile and Web App',
    thumbnail: '/assets/projects/thumbnails/gyansetu.png',
    description: 'GYANSETU is an educational app designed for low-bandwidth areas, offering offline access to courses, quizzes, materials, and more.',
    technologies: ['Flutter','Dart', 'HTML', 'CSS', 'JavaScript', 'Firebase'],
    projectLink: 'https://appetize.io/app/b_ewjwwoxe2jw6hapx4f5tstjwxa',
    mobileScreenshots: [
      '/assets/projects/gyansetu/1.jpg',
      '/assets/projects/gyansetu/2.jpg',
      '/assets/projects/gyansetu/3.jpg',
      '/assets/projects/gyansetu/4.jpg',
      '/assets/projects/gyansetu/5.jpg',
      '/assets/projects/gyansetu/6.jpg',
      '/assets/projects/gyansetu/7.jpg',
      '/assets/projects/gyansetu/8.jpg',
      '/assets/projects/gyansetu/9.jpg',
      '/assets/projects/gyansetu/10.jpg',
      '/assets/projects/gyansetu/11.jpg',
      '/assets/projects/gyansetu/12.jpg',
      '/assets/projects/gyansetu/13.jpg',
    ],
    detailedDescription: 'GYANSETU is an innovative mobile application built to support education in rural and remote areas, where internet connectivity can be limited. The app provides access to a wide range of educational content, including interactive AR/VR, quizzes, curriculum materials, discussion forum, chat functionalities, offline in-app file sharing, chatbot, and more. Optimized for low-bandwidth environments, GYANSETU ensures a smooth learning experience even with limited internet access. It also features offline functionality, allowing students to download and access PDF notes and study materials anytime, anywhere, without requiring a constant internet connection. With a user-friendly interface and a focus on accessibility, GYANSETU is dedicated to empowering students and improving educational outcomes.'
  },
  {
    id: 2,
    title: 'Website development for Mahi-Eco club',
    thumbnail: '/assets/projects/thumbnails/mahieco.png',
    description: 'Developed a comprehensive website for the Mahi-Eco Club of Amrita Vishwa Vidyapeetham, Chennai, to promote environmental awareness and activities within the college community.',
    technologies: ['HTML', 'CSS/SCSS', 'JavaScript', 'BootStrap'],
    projectLink: 'https://mahieco.netlify.app/',
    screenshots: [
      '/assets/projects/mahieco/1.png',
      '/assets/projects/mahieco/2.jpg',
      '/assets/projects/mahieco/3.jpg',
      '/assets/projects/mahieco/4.png',
      '/assets/projects/mahieco/5.jpg',
      '/assets/projects/mahieco/6.png',
      '/assets/projects/mahieco/7.jpg',
      '/assets/projects/mahieco/8.jpg'
    ],
    detailedDescription: 'This website is dedicated to Mahi, the Environment Club at Amrita Vishwa Vidhyapeetham, Chennai. It promotes environmental awareness and sustainability through activities like tree planting, wildlife conservation, and educational workshops. Built using HTML, CSS, and JavaScript, the site leverages modern web technologies to provide an engaging and informative user experience, helping to inspire and mobilize the community towards environmental conservation.'
  },
];
